import styled from 'styled-components';

import { Modal } from '@dexma/ui-components';

export const StyledFormSubmitModal = styled(Modal)`
    .buttons {
        margin-top: 30px;
        text-align: right;
        .cancel {
            margin-left: 10px;
        }
        button {
            margin: 0 5px 0 5px;
        }
        // Todo fix on the ui library
        svg,
        .StyledSpinner-iA-dccK {
            border-color: rgb(255 255 255) rgba(255, 255, 255, 0.1) rgba(255, 255, 255, 0.1);
            margin-right: 5px;
        }
    }
`;
